import Page from './Page';
import reducer from './reducer';

export const reducers = { PortManager: reducer };
export default { Page, reducers };